import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio
} from "@mui/material";

const PositionControls = ({ value, onChange, label, positions = [] }) => {
  return (
    <FormControl component="fieldset">
      <FormLabel component="legend" sx={{ mb: 1 }}>
        {label}
      </FormLabel>
      <RadioGroup
        row
        value={value || "left"}
        onChange={(e) => onChange(e.target.value)}
      >
        {positions.map((pos) => (
          <FormControlLabel
            key={pos.value}
            value={pos.value}
            control={<Radio sx={{ color: "#1976d2" }} />}
            label={pos.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default PositionControls;
